import 'construct-style-sheets-polyfill'; const styleSheet = new CSSStyleSheet(); styleSheet.replaceSync(`::-webkit-calendar-picker-indicator {
    background-image: url('../../assets/images/calendar.svg');
    background-size: 1.2em 1.2em;
}
`); export default styleSheet;